import script from "./CompanyContactListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyContactListView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyContactListView.vue?vue&type=style&index=0&id=1dffcc3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dffcc3a"]])

export default __exports__